import {
  LIST_BMI_CRITERIA_REQUEST,
  LIST_BMI_CRITERIA_SUCCESS,
  LIST_BMI_CRITERIA_FAIL,
  LIST_BMI_CRITERIA_SUMMARY_REQUEST,
  LIST_BMI_CRITERIA_SUMMARY_SUCCESS,
  LIST_BMI_CRITERIA_SUMMARY_FAIL,
  CREATE_BMI_CRITERIA_REQUEST,
  CREATE_BMI_CRITERIA_SUCCESS,
  CREATE_BMI_CRITERIA_FAIL,
  DETAIL_BMI_CRITERIA_REQUEST,
  DETAIL_BMI_CRITERIA_SUCCESS,
  DETAIL_BMI_CRITERIA_FAIL,
  UPDATE_BMI_CRITERIA_REQUEST,
  UPDATE_BMI_CRITERIA_SUCCESS,
  UPDATE_BMI_CRITERIA_FAIL,
  UPDATE_BMI_CRITERIA_DEFAULT_REQUEST,
  UPDATE_BMI_CRITERIA_DEFAULT_SUCCESS,
  UPDATE_BMI_CRITERIA_DEFAULT_FAIL,
  DELETE_BMI_CRITERIA_REQUEST,
  DELETE_BMI_CRITERIA_SUCCESS,
  DELETE_BMI_CRITERIA_FAIL,
  RESET_BMI_CRITERIA,
  SUMMARY_WA_TEMPLATES_REQUEST,
  SUMMARY_WA_TEMPLATES_SUCCESS,
  SUMMARY_WA_TEMPLATES_FAIL
} from '../../constants/bmi-criteries'

const initialState = {
  loading: false,
  bmiCriteries: [],
  summaryWaTemplates: [],
  bmiCriteria: {},
  error: null,
  pageable: {}
}

const bmiCriteriaReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BMI_CRITERIA_REQUEST:
      return { ...state, loading: true }
    case LIST_BMI_CRITERIA_SUCCESS:
      return { ...state, loading: false, bmiCriteries: action.payload, pageable: action.pageable }
    case LIST_BMI_CRITERIA_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_BMI_CRITERIA_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_BMI_CRITERIA_SUMMARY_SUCCESS:
      return { ...state, loading: false, bmiCriteries: action.payload }
    case LIST_BMI_CRITERIA_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_BMI_CRITERIA_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_BMI_CRITERIA_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_BMI_CRITERIA_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_BMI_CRITERIA_REQUEST:
      return { loadingDetail: true }
    case DETAIL_BMI_CRITERIA_SUCCESS:
      return { loadingDetail: false, bmiCriteria: action.payload }
    case DETAIL_BMI_CRITERIA_FAIL:
      return { loadingDetail: false, error: action.payload }
    case UPDATE_BMI_CRITERIA_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_BMI_CRITERIA_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BMI_CRITERIA_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case UPDATE_BMI_CRITERIA_DEFAULT_REQUEST:
      return { ...state, loadingUpdateDefault: true }
    case UPDATE_BMI_CRITERIA_DEFAULT_SUCCESS:
      return { ...state, loadingUpdateDefault: false }
    case UPDATE_BMI_CRITERIA_DEFAULT_FAIL:
      return { ...state, loadingUpdateDefault: false, error: action.payload }
    case DELETE_BMI_CRITERIA_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_BMI_CRITERIA_SUCCESS:
      const bmiCriteriaId = action.payload
      const indexServiceCategory = state.bmiCriteries.findIndex(bmiCriteria => bmiCriteria.id === bmiCriteriaId)
      state.bmiCriteries.splice(indexServiceCategory, 1)

      return { ...state, loadingDelete: false }
    case DELETE_BMI_CRITERIA_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_BMI_CRITERIA:
      return { ...state, loading: false, error: null }
    case SUMMARY_WA_TEMPLATES_REQUEST:
      return { ...state, loading: true }
    case SUMMARY_WA_TEMPLATES_SUCCESS:
      return { ...state, loading: false, summaryWaTemplates: action.payload }
    case SUMMARY_WA_TEMPLATES_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default bmiCriteriaReducer